import { ScoreCard, ScoreMatrixCellValue } from "../types";

/** Normalize API data that may be a single matrix (2D) or paginated matrices (3D). */
export const normalizeScoreMatrix = (
  scoreMatrix: ScoreCard[] | ScoreCard | null | undefined,
): ScoreCard[] => {
  if (!scoreMatrix || !Array.isArray(scoreMatrix) || scoreMatrix.length === 0) {
    return [];
  }
  const first = scoreMatrix[0];
  if (Array.isArray(first) && Array.isArray(first[0])) {
    return scoreMatrix as ScoreCard[];
  }
  if (Array.isArray(first)) {
    return [scoreMatrix as ScoreCard];
  }
  return [];
};

export const isValidMatrix = (scorecard?: ScoreCard) => {
  if (!Array.isArray(scorecard) || scorecard.length === 0) {
    return false;
  }
  if (!scorecard.every(row => Array.isArray(row) && row.length > 0)) {
    return false;
  }
  if (
    scorecard
      .flat()
      .some(
        score =>
          typeof score !== "number" &&
          typeof score !== "string" &&
          (typeof score !== "object" || !score || !("ascending" in score || "value" in score)),
      )
  ) {
    return false;
  }
  return true;
};

export const parseCellValue = (cell: ScoreMatrixCellValue) => {
  if (typeof cell === "object") {
    return cell.value as number;
  }
  return cell as number;
};
